import { render, staticRenderFns } from "./risk-release.vue?vue&type=template&id=74ed2039"
import script from "./risk-release.vue?vue&type=script&lang=js"
export * from "./risk-release.vue?vue&type=script&lang=js"
import style0 from "./risk-release.vue?vue&type=style&index=0&id=74ed2039&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports